module.exports = __webpack_public_path__ + "fonts/DINPro-Light.29e1cbaf.ttf";